import { render } from "./GuessThePayout.vue?vue&type=template&id=208cc76f"
import script from "./GuessThePayout.vue?vue&type=script&lang=js"
export * from "./GuessThePayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__